import { render, staticRenderFns } from "./player-settings.vue?vue&type=template&id=de96011c&scoped=true&"
import script from "./player-settings.ts?vue&type=script&lang=ts&"
export * from "./player-settings.ts?vue&type=script&lang=ts&"
import style0 from "./player-settings.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./player-settings.vue?vue&type=style&index=1&id=de96011c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de96011c",
  null
  
)

export default component.exports